const fetchJson = async ({ cache_url }) => {
  if (!cache_url) return null;
  try {
    const response = await fetch(cache_url, {
      method: 'GET',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
    });
    if (!response.ok) return null;
    return await response.json();
  } catch {
    return null;
  }
};

/**
 * AWS S3 → ローカルWP の順でJSONキャッシュを取得する
 * タイムスタンプはキャッシュバスティングのため付与
 */
export const checkAllJson = async ({ cache_name }) => {
  const ts = Date.now();
  const awsUrl = `https://tshibuya-calendar-json-bucket.s3.ap-northeast-1.amazonaws.com/${cache_name}_.json?state=${ts}`;
  const wpLocalUrl = `/wp/wp-content/themes/newtower_theme/cache/${cache_name}_.json?state=${ts}`;

  const res = (await fetchJson({ cache_url: awsUrl }))
    ?? (await fetchJson({ cache_url: wpLocalUrl }))
    ?? {};
  return res;
};
